
//@flow
import BaseComponent from '../base_component/base_component'
import componentLocator from '../../assets/javascripts/component_locator'
import TagSection from './tag_section'
import 'bootstrap-datepicker';

import type DataTable from '../data_Table/data_table'

export default class FilterPanel extends BaseComponent {
    isOpen: boolean;
    dateSet: boolean;
    $component: JQuery;
    datePickers: JQuery;
    tagContainer: JQuery;
    tagSections: TagSection[];
    dataTables: DataTable[]
    callbacks: (boolean => void)[]

    // TODO: Filter panel takes 100ms to initialise due to a *lot* of jquery selectors.
    // These can be significantly reduced via n+1 techniques,
    // but it's probably not a priority for now.
    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
        this.isOpen = false;
        this.$component = $(this.component);
        this.dataTables = [];
        this.callbacks = [];

        this.initPanel();
        this.initFiltering(options['tag_filters']);
    }

    finalize() {
        this.resetDateFilter();
        $(this.component).find('input[type="checkbox"]:checked').click();
    }

    initPanel() {
        this.datePickers = this.$component.find('.datepicker');
        this.datePickers.on('keydown', (e) => {
            if (e.key === 'Backspace') {
                this.resetDateFilter();
            }
        });
        this.tagContainer = this.$component.find('.selected-tags');

        this.initDatePicker();
        this.$component.find('.screen,.search-button').on('click', () => this.closePanel());
        this.$component.find('.clear-button').on('click', () => this.closePanel(true));
    }

    initDatePicker() {
        this.$component.find('.datepicker-container').datepicker({
            inputs: this.datePickers,
            format: (this.options.date_format || 'dd/mm/yyyy'),
            autoclose: true,
            keepEmptyValues: true,
            orientation: 'bottom'
        });
    }

    async initFiltering(tagFilters: {[string]: string[]}[]) {
        this.dataTables = await componentLocator.getAll('data_table');
        this.tagSections = $(this.$component).find('.tag_filters').children().toArray().map(element => {
            let name = element.getAttribute('data-group-name') || '';
            return new TagSection(name, this, element);
        })

        this.datePickers.change(this.filterDates.bind(this));
    }

    filterDates(picker) {
        let start = $(this.datePickers[0]);
        let end = $(this.datePickers[1]);
        if (start.val() === '' && end.val() === '') {
            return this.removePill('dateRange');
        };
        if (start.val() === '' || end.val() == '') {
            (start.val() == '' ? start : end).datepicker('show');
            return;
        }
        this.dateSet = true;

        let startDate = start.datepicker('getUTCDate');
        let endDate = end.datepicker('getUTCDate');
        this.showPill('dateRange',
            `${(start.val(): any)} - ${(end.val(): any)}`,
            this.resetDateFilter.bind(this));
        this.dataTables.forEach(dt => dt.addFilter('Date').dateRange(startDate, endDate));
    }

    showPill(key: string, text: string, callback: () => any) {
        this.removePill(key, true);
        let pill = `
            <button class="btn btn-default" type="button" data-key="${key}">
                <span class="glyphicon glyphicon-remove"></span> ${text}
            </button>
        `
        let $tags = this.tagContainer.append(pill);
        $tags.find(`[data-key="${key}"]`).click(callback);
    }

    removePill(key: string, adding: boolean = false) {
        let pill = $(this.component).find(`[data-key="${key}"]`)
        this.tagContainer.toggleClass('empty',
            !!(pill.length && this.tagContainer.children().length <= 1 && !adding));
        return pill.remove();
    }
    
    closePanel(reset: boolean = false) {
        this.toggle(false);

        if (reset) this.finalize();

        this.tagSections && this.tagSections.forEach(section => section.toggle(false));
    }

    resetDateFilter() {
        this.datePickers.datepicker('clearDates');
        this.dataTables.forEach(dt => dt.removeFilter('Date').dateRange());
        this.removePill('dateRange');
        this.dateSet = false;
    }

    toggle(isOpen: ?boolean) {
        this.isOpen = isOpen == null ? !this.isOpen : isOpen;
        this.$component.find('.filters-panel').toggleClass('active', this.isOpen);
        this.$component.find('.screen').toggleClass('active', this.isOpen);
        this.callbacks.forEach(callback => callback(this.isOpen));
        if (isOpen) {
            componentLocator.getAll('user_panel')
                .then(panel => panel.forEach((p: any) => p.toggle(false)));
        }
    }
}